import { Skeleton } from "./ui/skeleton";

export default function LoadingCard() {
  return (
    <div className="space-y-4 max-w-xl mx-auto pt-4">
      <Skeleton className="h-12" />
      <Skeleton className="h-8" />
      <Skeleton className="h-48" />
    </div>
  );
}
